// import actions
import institucionAction from './actions/institucion'
import ubigeoAction from './actions/ubigeo'
import proyectoAction from './actions/proyecto'
import grupoOpcionAction from './actions/grupoOpcion'
import encuestadoAction from './actions/encuestado'
import opcionAction from './actions/opcion'
import encuestaAction from './actions/encuesta'
import authAction from './actions/auth'
import preguntaAction from './actions/pregunta'
import bloqueAction from './actions/bloque'
import usuarioAction from './actions/usuario'
import proyectoUsuarioAction from './actions/proyectoUsuario'
import tipoPreguntaAction from './actions/tipoPregunta'
import aparienciaAction from './actions/apariencia'
import parcelaAction from './actions/parcela'
import parcelaCoordenadaAction from './actions/parcelaCoordenada'
import tableroIndicadorAction from './actions/tableroIndicador'
import encuestadorAction from './actions/encuestador'

// import getters
import institucionGetter from './getters/institucion'
import proyectoGetter from './getters/proyecto'
import grupoOpcionGetter from './getters/grupoOpcion'
import encuestadoGetter from './getters/encuestado'
import opcionGetter from './getters/opcion'
import encuestaGetter from './getters/encuesta'
import authGetter from './getters/auth'
import preguntaGetter from './getters/pregunta'
import bloqueGetter from './getters/bloque'
import usuarioGetter from './getters/usuario'
import proyectoUsuarioGetter from './getters/proyectoUsuario'
import tipoPreguntaGetter from './getters/tipoPregunta'
import aparienciaGetter from './getters/apariencia'
import parcelaGetter from './getters/parcela'
import parcelaCoordenadaGetter from './getters/parcelaCoordenada'
import indicadorGetter from './getters/indicador'

// import mutations
import institucionMutation from './mutations/institucion'
import ubigeoMutation from './mutations/ubigeo'
import proyectoMutation from './mutations/proyecto'
import grupoOpcionMutation from './mutations/grupoOpcion'
import encuestadoMutation from './mutations/encuestado'
import opcionMutation from './mutations/opcion'
import encuestaMutation from './mutations/encuesta'
import authMutation from './mutations/auth'
import preguntaMutation from './mutations/pregunta'
import bloqueMutation from './mutations/bloque'
import usuarioMutation from './mutations/usuario'
import proyectoUsuarioMutation from './mutations/proyectoUsuario'
import tipoPreguntaMutation from './mutations/tipoPregunta'
import aparienciaMutation from './mutations/apariencia'
import parcelaMutation from './mutations/parcela'
import parcelaCoordenadaMutation from './mutations/parcelaCoordenada'
import indicadorMutation from './mutations/indicador'

// import states
import institucionState from './states/institucion'
import ubigeoState from './states/ubigeo'
import proyectoState from './states/proyecto'
import grupoOpcionState from './states/grupoOpcion'
import encuestadoState from './states/encuestado'
import opcionState from './states/opcion'
import encuestaState from './states/encuesta'
import authState from './states/auth'
import preguntaState from './states/pregunta'
import bloqueState from './states/bloque'
import usuarioState from './states/usuario'
import proyectoUsuarioState from './states/proyectoUsuario'
import tipoPreguntaState from './states/tipoPregunta'
import aparienciaState from './states/apariencia'
import parcelaState from './states/parcela'
import parcelaCoordenadaState from './states/parcelaCoordenada'
import indicadorState from './states/indicador'

const actions = {
  ...institucionAction,
  ...ubigeoAction,
  ...proyectoAction,
  ...grupoOpcionAction,
  ...encuestadoAction,
  ...opcionAction,
  ...encuestaAction,
  ...authAction,
  ...preguntaAction,
  ...bloqueAction,
  ...usuarioAction,
  ...proyectoUsuarioAction,
  ...tipoPreguntaAction,
  ...aparienciaAction,
  ...parcelaAction,
  ...parcelaCoordenadaAction,
  ...tableroIndicadorAction,
  ...encuestadorAction,
}

const getters = {
  ...institucionGetter,
  ...proyectoGetter,
  ...grupoOpcionGetter,
  ...encuestadoGetter,
  ...opcionGetter,
  ...encuestaGetter,
  ...authGetter,
  ...preguntaGetter,
  ...bloqueGetter,
  ...usuarioGetter,
  ...proyectoUsuarioGetter,
  ...tipoPreguntaGetter,
  ...aparienciaGetter,
  ...parcelaGetter,
  ...parcelaCoordenadaGetter,
  ...indicadorGetter,
}

const mutations = {
  ...institucionMutation,
  ...ubigeoMutation,
  ...proyectoMutation,
  ...grupoOpcionMutation,
  ...encuestadoMutation,
  ...opcionMutation,
  ...encuestaMutation,
  ...authMutation,
  ...preguntaMutation,
  ...bloqueMutation,
  ...usuarioMutation,
  ...proyectoUsuarioMutation,
  ...tipoPreguntaMutation,
  ...aparienciaMutation,
  ...parcelaMutation,
  ...parcelaCoordenadaMutation,
  ...indicadorMutation,
}
const state = {
  ...institucionState,
  ...ubigeoState,
  ...proyectoState,
  ...grupoOpcionState,
  ...encuestadoState,
  ...opcionState,
  ...encuestaState,
  ...authState,
  ...preguntaState,
  ...bloqueState,
  ...usuarioState,
  ...proyectoUsuarioState,
  ...tipoPreguntaState,
  ...aparienciaState,
  ...parcelaState,
  ...parcelaCoordenadaState,
  ...indicadorState,
}

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
